import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { DetalleOT, EvidenciaImg } from "../types/ot.types";
import { EvidenciasReparacionPorConcepto } from "./EvidenciasReparacionPorConcepto";

interface ModalEvidenciasCierreProps {
  show: boolean;
  onClose: () => void;
  onSave?: () => void;
  detallesOT: DetalleOT[];
  evidenciasCierre: Record<number, EvidenciaImg[]>;
  setEvidenciasCierre: React.Dispatch<
    React.SetStateAction<Record<number, EvidenciaImg[]>>
  >;
  isSaving?: boolean;
  title?: string;
  saveLabel?: string;
  readOnly?: boolean;
}

export const ModalEvidenciasCierre: React.FC<ModalEvidenciasCierreProps> = ({
  show,
  onClose,
  onSave,
  detallesOT,
  evidenciasCierre,
  setEvidenciasCierre,
  isSaving = false,
  title = "Evidencia de reparación complementaria",
  saveLabel = "Guardar evidencias",
  readOnly = false,
}) => {
  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

  return createPortal(
    <>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div
        className="modal fade show d-block"
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                <i className="fas fa-camera me-2 text-primary"></i>
                {title}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Cerrar"
              ></button>
            </div>
            <div className="modal-body">
              <p className="text-muted small">
                Cargue fotografías o videos que evidencien la finalización de la
                reparación por concepto autorizado.
              </p>
              <EvidenciasReparacionPorConcepto
                detallesOT={detallesOT}
                evidenciasInicio={{}}
                evidenciasCierre={evidenciasCierre}
                setEvidenciasCierre={readOnly ? undefined : setEvidenciasCierre}
                modo="solo_cierre"
                isCompleted={readOnly}
                compact
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
                disabled={isSaving}
              >
                Cerrar
              </button>
              {!readOnly && onSave && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSave}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <>
                      <i className="fas fa-spinner fa-spin me-1"></i> Guardando...
                    </>
                  ) : (
                    saveLabel
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};
